/* Oh Orchid — header / navigation behaviour
   Generated from the Claude Design build, 2026-08-20.

   The cart drawer, search results and review figure are rendered by Liquid in
   sections/oo-header.liquid. No product name, price or total is hard-coded here.

   After an AJAX cart change, call ooUpdateCart(cart) with Shopify's cart JSON
   so the count, subtotal and free-shipping band recompute together.
*/
/* ---- component-oo-header.js ---------------------------------------- */
(function () {
  var root = document.querySelector('[data-oo-root]');
  if (!root) return;

  /* ---- Sticky compact state ----------------------------------------
     Plain scroll position, deliberately.

     This previously used an IntersectionObserver against a 1px sentinel
     injected before the header. That worked in a standalone HTML file, where
     the header's parent was <body>. Inside a Shopify section it does not:
     the sentinel lands inside the section wrapper, its containing block
     changes, and the observer's first callback can fire before layout has
     settled — reporting "not intersecting", latching the header into its
     compact state, and never firing again because nothing subsequently
     changes the sentinel's intersection.

     Scroll position has no such dependency on DOM context or layout timing,
     and it no longer injects a node into the theme's markup.               */
  function ooSyncStuck() {
    root.dataset.stuck = (window.scrollY || window.pageYOffset || 0) > 40 ? 'true' : 'false';
  }
  ooSyncStuck();                                        /* correct on load */
  window.addEventListener('scroll', ooSyncStuck, { passive: true });

  /* ---- Desktop mega-menu: hover with close delay, plus keyboard ----- */
  var doors = root.querySelectorAll('[data-oo-door]');
  var timer;
  function openDoor(door) {
    clearTimeout(timer);
    doors.forEach(function (d) {
      var on = d === door;
      d.dataset.open = on ? 'true' : 'false';
      var b = d.querySelector('button');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  function closeDoors() { openDoor(null); }

  doors.forEach(function (door) {
    var btn = door.querySelector('button');
    if (!btn) return;
    door.addEventListener('mouseenter', function () { closeSearch(); openDoor(door); });
    door.addEventListener('mouseleave', function () { timer = setTimeout(closeDoors, 160); });
    btn.addEventListener('click', function () {
      door.dataset.open === 'true' ? closeDoors() : openDoor(door);
    });
    btn.addEventListener('focus', function () { openDoor(door); });
  });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeDoors(); });

  /* ---- Search overlay ---------------------------------------------- */
  function openSearch() {
    closeDoors();
    root.dataset.search = 'open';
    var i = root.querySelector('[data-oo-search-input]');
    if (i) { i.focus(); i.select(); }
  }
  function closeSearch() { root.dataset.search = 'closed'; }
  root.querySelectorAll('[data-oo-open-search]').forEach(function (b) {
    b.addEventListener('click', openSearch);
  });
  root.querySelectorAll('[data-oo-close-search]').forEach(function (b) {
    b.addEventListener('click', closeSearch);
  });

  /* ---- Panels: drawer + cart --------------------------------------- */
  var lastFocus = null, openPanelEl = null, lockedY = 0;
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /* `overflow: hidden` on body does not hold in iOS Safari — pin the body at
     its scroll offset instead and restore it on close. */
  function lock(on) {
    if (on) {
      lockedY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -lockedY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, lockedY);
    }
  }

  function focusablesIn(el) {
    return Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE),
      function (n) { return n.offsetParent !== null; });
  }

  function openPanel(which) {
    if (root.dataset[which] === 'open') return;
    closeDoors(); closeSearch();
    lastFocus = document.activeElement;
    root.dataset[which] = 'open';
    lock(true);
    /* Both panels declare aria-modal="true", which hides the rest of the page
       from screen readers — leaving focus outside strands the user. */
    openPanelEl = root.querySelector(which === 'cart' ? '[data-oo-cart]' : '[data-oo-drawer]');
    if (openPanelEl) {
      var first = openPanelEl.querySelector('[data-oo-close-all]') || focusablesIn(openPanelEl)[0];
      if (first) first.focus();
    }
  }

  function closeAll() {
    var wasOpen = root.dataset.drawer === 'open' || root.dataset.cart === 'open';
    root.dataset.drawer = 'closed';
    root.dataset.cart = 'closed';
    closeSearch();
    if (wasOpen) lock(false);
    var b = root.querySelector('[data-oo-open-drawer]');
    if (b) b.setAttribute('aria-expanded', 'false');
    openPanelEl = null;
    if (wasOpen && lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  /* Tab wraps at the ends of whichever dialog is open. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !openPanelEl) return;
    var items = focusablesIn(openPanelEl);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  root.querySelectorAll('[data-oo-open-drawer]').forEach(function (b) {
    b.addEventListener('click', function () {
      openPanel('drawer');
      b.setAttribute('aria-expanded', 'true');
    });
  });
  root.querySelectorAll('[data-oo-open-cart]').forEach(function (b) {
    b.addEventListener('click', function () { openPanel('cart'); });
  });
  root.querySelectorAll('[data-oo-close-all]').forEach(function (b) {
    b.addEventListener('click', closeAll);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDoors(); closeAll(); }
  });

  /* ---- Mobile accordion: one open at a time ------------------------ */
  var PLUS = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';
  var MINUS = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path></svg>';
  root.querySelectorAll('[data-oo-acc] > button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var acc = btn.parentElement;
      var wasOpen = acc.dataset.open === 'true';
      root.querySelectorAll('[data-oo-acc]').forEach(function (a) {
        a.dataset.open = 'false';
        var s = a.querySelector('.oo-acc-sign'); if (s) s.innerHTML = PLUS;
        var b = a.querySelector('button'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        acc.dataset.open = 'true';
        acc.querySelector('.oo-acc-sign').innerHTML = MINUS;
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ---- Free-shipping band ------------------------------------------
     In the theme, render the copy and width from Liquid on first paint,
     then call this after every cart update so it stays in sync.        */
  window.ooUpdateShipping = function (subtotalCents, thresholdCents) {
    var t = thresholdCents || 7500;
    var copy = root.querySelector('[data-oo-ship-copy]');
    var bar = root.querySelector('[data-oo-ship-bar]');
    if (!copy || !bar) return;
    var pct = Math.min(100, Math.round((subtotalCents / t) * 100));
    bar.style.width = pct + '%';
    copy.textContent = subtotalCents >= t
      ? 'Your order ships complimentary'
      : '$' + Math.ceil((t - subtotalCents) / 100) + ' away from complimentary shipping';
  };
})();

/* ---- Cart totals updater -------------------------------------------
   Liquid renders these nodes on load. Call this after an AJAX add-to-cart or
   quantity change with the JSON from /cart.js. Count, subtotal and the
   free-shipping band are derived from one source here for the same reason
   they are in Liquid: three separately-maintained numbers drift apart.
   The threshold is read from the drawer, which Liquid writes from the section
   setting — one place to change it.                                        */
window.ooUpdateCart = function (cart) {
  if (!cart) return;
  var root = document.querySelector('[data-oo-root]');
  if (!root) return;

  var shipEl    = root.querySelector('[data-oo-ship]');
  var threshold = shipEl ? parseInt(shipEl.getAttribute('data-oo-ship-threshold'), 10) : 0;
  var cents     = cart.total_price || 0;
  var count     = cart.item_count || 0;

  function money (c) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(c);
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }

  root.querySelectorAll('[data-oo-cart-count]').forEach(function (n) { n.textContent = count; });
  var label = root.querySelector('[data-oo-cart-label]');
  if (label) label.textContent = count + (count === 1 ? ' item' : ' items');
  var sub = root.querySelector('[data-oo-cart-subtotal]');
  if (sub) sub.textContent = money(cents);

  if (threshold > 0) {
    var gap  = threshold - cents;
    var copy = root.querySelector('[data-oo-ship-copy]');
    var bar  = root.querySelector('[data-oo-ship-bar]');
    if (copy) copy.textContent = gap > 0
      ? money(gap) + ' away from complimentary shipping'
      : 'Complimentary shipping unlocked';
    if (bar) bar.style.width = Math.min(100, Math.round(cents / threshold * 100)) + '%';
  }
};

/* ---- Cart quantity controls -----------------------------------------
   The +/- buttons in the drawer had no handler at all: Liquid rendered the
   quantity, and clicking either control did nothing. They now commit the
   change server-side through /cart/change.js and re-render from the cart
   JSON that comes back, so the line, the count, the subtotal and the
   free-shipping band all move from one source.
   Delegated from document because the drawer's contents are replaced when
   the cart changes, which would strip per-node listeners.                */
(function () {
  var busy = false;
  var needsRefresh = false;

  function money (c) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(c);
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-oo-qty]');
    if (!btn || busy || needsRefresh) return;

    var root = btn.closest('[data-oo-root]');
    var wrap = root && root.querySelector('[data-oo-cart-items]');
    var line = btn.closest('.oo-line');
    var key  = btn.getAttribute('data-oo-key');
    var span = line && line.querySelector('.oo-qty span');
    if (!wrap || !line || !key || !span) return;

    var lines = Array.prototype.slice.call(wrap.querySelectorAll('.oo-line'));
    if (lines.indexOf(line) < 0) return;

    var next = parseInt(span.textContent, 10) + parseInt(btn.getAttribute('data-oo-qty'), 10);
    if (isNaN(next) || next < 0) return;

    var co = root.querySelector('.oo-checkout');
    var checkoutDisabled = co ? co.disabled : false;
    var form = root.querySelector('#oo-cart-form');
    var error = root.querySelector('[data-oo-cart-error]');
    var genericError = window.cartStrings && window.cartStrings.error || 'There was an error while updating your cart. Please try again.';
    if (error) error.remove();
    busy = true;
    line.style.opacity = '.5';
    wrap.setAttribute('aria-busy', 'true');
    if (co) co.disabled = true;

    var route = window.routes && window.routes.cart_change_url ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/change.js';
    fetch(route, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: next })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var failure = new Error(genericError);
            failure.userMessage = data && typeof data.description === 'string' ? data.description : genericError;
            throw failure;
          }
          return data;
        });
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count) ||
            cart.item_count < 0 || !Number.isInteger(cart.total_price) || cart.total_price < 0 ||
            !cart.items.every(function (item) {
              return item && typeof item.key === 'string' && item.key.length > 0 &&
                Number.isInteger(item.quantity) && item.quantity > 0 &&
                Number.isInteger(item.final_line_price) && item.final_line_price >= 0;
            }) || cart.items.reduce(function (count, item) { return count + item.quantity; }, 0) !== cart.item_count) {
          throw new Error(genericError);
        }

        var remaining = lines.filter(function (row) { return next !== 0 || row !== line; });
        var variants = remaining.map(function (row) { return row.querySelector('[data-oo-key]').getAttribute('data-oo-key').split(':')[0]; });
        if (remaining.length !== cart.items.length || !remaining.every(function (row, index) {
          var oldKey = row.querySelector('[data-oo-key]').getAttribute('data-oo-key');
          var newKey = cart.items[index].key;
          return variants[index] === newKey.split(':')[0] &&
            (variants.indexOf(variants[index]) === variants.lastIndexOf(variants[index]) || oldKey === newKey);
        })) {
          needsRefresh = true;
          checkoutDisabled = true;
          wrap.querySelectorAll('[data-oo-qty]').forEach(function (control) { control.disabled = true; });
          throw new Error(genericError);
        }

        if (next === 0) line.remove();
        remaining.forEach(function (row, index) {
          var item = cart.items[index];
          row.querySelector('.oo-qty span').textContent = item.quantity;
          var price = row.querySelector('.oo-line-foot > span');
          if (price) price.textContent = money(item.final_line_price);
          row.querySelectorAll('[data-oo-key]').forEach(function (control) { control.setAttribute('data-oo-key', item.key); });
        });
        checkoutDisabled = cart.item_count === 0;
        if (checkoutDisabled) {
          wrap.innerHTML = '<div class="oo-cart-empty"><p class="oo-quiet">Your bag is empty.</p>' +
            '<a class="oo-cta" href="/collections/best-sellers">Shop best sellers</a></div>';
        }
        if (window.ooUpdateCart) window.ooUpdateCart(cart);
      })
      .catch(function (failure) {
        var foot = root.querySelector('.oo-cart-foot');
        if (!foot) return;
        error = document.createElement('p');
        error.className = 'oo-cart-error oo-quiet';
        error.setAttribute('data-oo-cart-error', '');
        error.setAttribute('role', 'alert');
        error.textContent = (failure.userMessage || genericError) + ' ';
        var link = document.createElement('a');
        link.href = form ? form.action : (window.routes && window.routes.cart_url || '/cart');
        link.textContent = 'View your bag';
        error.appendChild(link);
        foot.prepend(error);
      })
      .then(function () {
        line.style.opacity = '';
        wrap.removeAttribute('aria-busy');
        if (co) co.disabled = checkoutDisabled;
        busy = false;
      });
  });
})();
